interface DISCOUNT_CALCULATOR {
  principalAmount: number | undefined;
  discountInterest: number | undefined;
}

export const DISCOUNT_FORMULA = ({
  principalAmount,
  discountInterest,
}: DISCOUNT_CALCULATOR) => {
  if (
    !principalAmount ||
    !discountInterest ||
    Number(principalAmount) < 0 ||
    Number(discountInterest) < 0
  )
    return { amountPayable: 0, discountAmount: 0 };
  const discount = (principalAmount * discountInterest) / 100;
  const netPayableAmount = principalAmount - discount;
  return {
    amountPayable: netPayableAmount,
    discountAmount: discount,
  };
};
